import React, {Component} from 'react';
import {BrowserView, MobileView,} from "react-device-detect";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import '../assets/css/result.css';
import '../assets/css/result_animation.css';
import ReactGA from 'react-ga';
import axios from 'axios';
import {effect_set, result_set} from '../assets/story_set'
import Ads from "./Ads";
import {API_URL, ADDY_URL} from "../config";

class Result extends Component {
    state = {
        result: result_set[this.props.match.params.id],
        is_like: false,
        per: 0,
        like: 0,
        id: this.props.match.params.id
    };

    async componentDidMount() {
        if (this.props.history.action === 'PUSH') {
            ReactGA.pageview('/jungle/result/' + this.state.id);
            axios.get(
                API_URL + '/api/v1/story/jungle/' + this.state.id,
                {
                    headers: {
                        'Authorization': "story_add_campus_312523"
                    }
                }).then(({data: {data}}) => {
                this.setState({
                    per: data.per,
                    like: data.like.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                })
            }).catch((e) => {
                axios.get(
                    ADDY_URL + '/api/v1/story/jungle/' + this.state.id,
                    {
                        headers: {
                            'Authorization': "story_add_campus_312523"
                        }
                    }).then(({data: {data}}) => {
                    this.setState({
                        per: data.per,
                        like: data.like.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    })
                })
            });
        } else {
            this.props.history.push('/')
        }
    }

    saveImage(url) {
        ReactGA.event({
            category: "Story-1 [쫄보테스트]",
            action: "Save",
            label: this.state.result.title
        });
        fetch(url)
            .then((img) => img.blob())
            .then((blob) => {
                let url = window.URL.createObjectURL(blob);
                let link = document.createElement('a');
                link.href = url;
                link.download = this.state.result.title + '.png';
                link.click();
            })
    }

    copyAlert(url) {
        ReactGA.event({
            category: "Story-1 [쫄보테스트]",
            action: "Share",
            label: this.state.result.title
        });
        if (navigator.share) {
            navigator.share({
                url: url
            }).then(() => {
                console.log('Thanks for sharing!');
            }).catch(console.error);
        } else {
            alert('복사 되었습니다.');
        }
    }

    async likeBtn() {
        ReactGA.event({
            category: "Story-1 [쫄보테스트]",
            action: "Like",
            label: this.state.result.title
        });
        axios.post(
            API_URL + '/api/v1/story/jungle/' + this.state.id,
            {},
            {
                headers: {
                    'Authorization': "story_add_campus_312523"
                }
            }).then(({data: {data}}) => {
            this.setState({
                is_like: true,
                like: data.like.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            })
        }).catch((e) => {
            axios.post(
                ADDY_URL + '/api/v1/story/jungle/' + this.state.id,
                {},
                {
                    headers: {
                        'Authorization': "story_add_campus_312523"
                    }
                }).then(({data: {data}}) => {
                this.setState({
                    is_like: true,
                    like: data.like.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                })
            })
        });
    }

    clickBanner() {
        ReactGA.event({
            category: "Story-1 [쫄보테스트]",
            action: "Banner",
            label: this.state.result.title
        });
        window.open("https://m.post.naver.com/viewer/postView.nhn?volumeNo=29039521&memberNo=47717099");
    }

    replay() {
        ReactGA.event({
            category: "Story-1 [쫄보테스트]",
            action: "Replay",
            label: this.state.result.title
        });
        this.props.history.push('/')
    }

    render() {
        const {result, is_like, per, like} = this.state;
        let like_btn = <button className="like_btn" onClick={() => this.likeBtn()}>완전 잘 맞는 것 같아요!</button>;
        let mobile_like_btn = <button className="mobile_like_btn" onClick={() => this.likeBtn()}>완전 잘 맞는 것
            같아요!</button>;
        let like_msg = "아무 정보도 안가져가요ㅠㅠ제발 눌러주세요 ㅠ퓨";
        if (is_like) {
            like_msg = "다음엔 더 재밌는 테스트로 찾아뵙겠습니다 충성!";
            like_btn =
                <button className="like_btn active"><span style={{opacity: 0.6}}>{like}</span> 명이 딱 맞대요!</button>;
            mobile_like_btn =
                <button className="mobile_like_btn active"><span style={{opacity: 0.6}}>{like}</span> 명이 딱 맞대요!
                </button>;
        }
        let pc_effect = [];
        let mobile_effect = [];
        if (result.effect) {
            for (let i = 0; i < result.effect.length; i++) {
                try {
                    pc_effect.push(...effect_set[result.effect[i]].pc);
                    mobile_effect.push(...effect_set[result.effect[i]].mobile);
                } catch (e) {
                    console.log(e)
                }
            }
        }
        return (
            <div className="result">
                <BrowserView>
                    <div className="background_img_compo">
                        <img className="result_background_img background_zoom" src={result.background_img_url}
                             alt="background"/>
                        <img className="result_foreground_img foreground_zoom" src={result.foreground_img_url}
                             alt="background"/>
                        {result.pc_obj_img_set}
                        {pc_effect}
                        <div className="result_background_dissolve"/>
                        <div className="result_wrapper">
                            <div className="result_img_text_compo">
                                <p className="result_img_sub_title">{result.sub_title}</p>
                                <p className="result_img_title">{result.title}</p>
                            </div>
                        </div>
                        <div className="result_wrapper">
                            <div style={{
                                textAlign: "right",
                                zIndex: 10,
                                width: "840px",
                                margin: "auto",
                                position: "absolute",
                                top: "532px"
                            }}>
                                <button className="per_label">{per.toFixed(1)}%</button>
                            </div>
                        </div>
                    </div>
                    <div className="result_wrapper">
                        <p className="result_main_title">
                            TENDOM 2020<br/>
                            <span style={{color: "#007aff"}}>쫄보유형검사</span> 결과발표!
                        </p>
                        <p className="result_main_desc">*본 검사는 초자연적 계시를 중심으로 설계되었을 뿐이니, 그저 그 뿐이니까 재미로 즐겨주시기
                            바랍니다.</p>
                        <div className="share_compo">
                            <div className="share_grid img_save_btn">
                                <img alt="icon" className="icon" onClick={() => this.saveImage(result.download_img_url)}
                                     src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/icon/group-7.svg"/>
                                <p className="text" onClick={() => this.saveImage(result.download_img_url)}>이미지 저장하기</p>
                            </div>
                        </div>
                        {result.desc_set ?
                            result.desc_set.map((desc, index) => {
                                let sub_title, ads;
                                if (index === 0) {
                                    sub_title =
                                        <p className="desc_sub_title">{per.toFixed(1)}% 사람이 {desc.desc_title} 래요!!</p>
                                    ads = <Ads style={{marginTop: "30px"}}/>;
                                }
                                return (
                                    <>
                                        <div key={index} className="result_desc_compo">
                                            <p className="desc_title">{desc.desc_title}</p>
                                            {sub_title}
                                            <p className="desc_sub_desc">{desc.desc_sub_desc}</p>
                                        </div>
                                        {ads}
                                    </>
                                )
                            }) : null
                        }
                        <div className="last_compo">
                            <div className="last_grid" style={{width: "184px"}}/>
                            <div className="last_grid" style={{width: "150px"}}>
                                <p className="last_text">이 친구들이랑<br/>
                                    <span style={{fontWeight: "bold"}}>잘 맞아요!</span>
                                </p>
                            </div>
                            <div className="last_grid_couple">
                                <img alt="couple_img" src={result.couple_img_url}
                                     style={{width: "72px", height: "72px", margin: '16px'}}/>
                                <p className="last_text">
                                        <span style={{
                                            fontWeight: "bold",
                                            fontSize: "22px"
                                        }}>{result.couple_title}</span><br/>
                                    {result.couple_desc}</p>
                            </div>
                        </div>

                        <div className="like_compo">
                            {like_btn}
                            <p className="like_desc">{like_msg}</p>
                        </div>
                        <div style={{textAlign: "right"}}>
                            <div className="pc_share_btn" onClick={() => this.replay()}>
                                <img alt="icon" className="icon"
                                     src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/icon/replay-gray.svg"/>
                                <p className="text">한번 더!</p>
                            </div>
                            <CopyToClipboard text={"https://story.addcampus.com/jungle"}
                                             onCopy={() => this.copyAlert("https://story.addcampus.com/jungle")}>
                                <div className="share_grid pc_share_btn">
                                    <img alt="icon" className="icon"
                                         src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/icon/group.svg"/>
                                    <p className="text">URL 복사하기</p>
                                </div>
                            </CopyToClipboard>
                        </div>
                        <p>2020 Copyright @ TENDOM. All rights reserved.</p>
                        <a href="mailto:info@tendom.co.kr" style={{color: "black"}}>Contact Us</a>
                    </div>
                </BrowserView>


                <MobileView>
                    <div className="mobile_background_img_compo">
                        <button className="mobile_img_save_btn"
                                onClick={() => this.saveImage(result.download_img_url)}>저장
                        </button>
                        <img className="mobile_result_background_img background_zoom" src={result.background_img_url}
                             alt="background"/>
                        <img className="mobile_result_foreground_img foreground_zoom" src={result.foreground_img_url}
                             alt="background"/>
                        {result.mobile_obj_img_set}
                        {mobile_effect}
                        <div className="mobile_result_background_dissolve"/>
                        <div className="mobile_img_text_compo">
                            <p className="mobile_img_sub_title">{result.sub_title}</p>
                            <p className="mobile_img_title">{result.title}</p>
                        </div>
                        <div>
                            <div style={{
                                textAlign: "right",
                                zIndex: 10,
                                width: "100%",
                                margin: "auto",
                                position: "absolute",
                                top: "310px",
                                right: "20px"
                            }}>
                                <button className="mobile_per_label">{per.toFixed(1)}%</button>
                            </div>
                        </div>
                    </div>
                    <div style={{marginTop: "420px"}}/>
                    {result.desc_set ?
                        result.desc_set.map((desc, index) => {
                            let sub_title, ads;
                            if (index === 0) {
                                sub_title = <p className="mobile_desc_sub_title">{per.toFixed(1)}%
                                    사람이 {desc.desc_title} 래요!!</p>
                                ads = <Ads style={{marginTop: "30px"}}/>;
                            }
                            return (
                                <>
                                    <div key={index} className="mobile_result_desc_compo">
                                        <p className="mobile_desc_title">{desc.desc_title}</p>
                                        {sub_title}
                                        <p className="mobile_desc_sub_desc">{desc.desc_sub_desc}</p>
                                    </div>
                                    {ads}
                                </>
                            )
                        }) : null
                    }
                    <div className="mobile_last_compo">
                        <p className="mobile_last_text">이 친구들이랑 잘 맞아요!</p>
                        <div className="mobile_last_grid_couple">
                            <img alt="couple_img" src={result.couple_img_url}
                                 style={{width: "58px", height: "58px", margin: '16px'}}/>
                            <p className="mobile_last_text">
                                        <span style={{
                                            fontWeight: "bold",
                                            fontSize: "18px"
                                        }}>{result.couple_title}</span><br/>
                                {result.couple_desc}</p>
                        </div>
                    </div>
                    <div className="mobile_like_compo">
                        {mobile_like_btn}
                        <p className="like_desc" style={{fontSize: "12px"}}>{like_msg}</p>
                    </div>
                    <div className="mobile_share_compo">
                        <p className="mobile_result_share_text">내 친구들은 어떤 유형일까요?</p>
                        <div className="share_btn" onClick={() => this.replay()}>
                            <img alt="icon" className="icon"
                                 src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/icon/replay.svg"/>
                            <p className="text">한번 더!</p>
                        </div>
                        <CopyToClipboard text={"https://story.addcampus.com/jungle"}
                                         onCopy={() => this.copyAlert("https://story.addcampus.com/jungle")}>
                            <div className="share_btn">
                                <img alt="icon" className="icon"
                                     src="https://addcampus-story.s3.ap-northeast-2.amazonaws.com/story/story_1/icon/share-white.svg"/>
                                <p className="text">공유하기</p>
                            </div>
                        </CopyToClipboard>
                    </div>
                    <p>2020 Copyright @ TENDOM. All rights reserved.</p>
                    <a href="mailto:info@tendom.co.kr" style={{color: "black"}}>Contact Us</a>
                </MobileView>
            </div>
        );
    }
}

export default Result;
